module.exports = __webpack_public_path__ + "img/bus-area-02.8406300f.png";